import { Outlet, createFileRoute, useMatchRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import ListPageHeader from '@/components/ListPageHeader';
import { ProductLogoMediumWageLedgers } from '@/components/Logo';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/wage-ledger/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.wageLedger'
  });
  useDocumentTitle(t('pageTitle'));
  const matchRoute = useMatchRoute();
  /** 台帳詳細は専用ヘッダーのため、モジュールの ListPageHeader は出さない */
  const isLedgerDetail = matchRoute({
    to: '/wage-ledger/ledger/$ledgerId',
    fuzzy: true
  });
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <div className="flex h-full min-h-0 min-w-0 flex-col">
      {!isLedgerDetail ? <ListPageHeader icon={<ProductLogoMediumWageLedgers />} title={t('pageTitle')} tabs={[{
      to: '/wage-ledger/overview',
      children: t('tabs.overview'),
      activeOptions: {
        exact: true
      }
    }, {
      to: '/wage-ledger/ledger',
      children: t('tabs.ledger'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/wage-ledger/alerts',
      children: t('tabs.alerts'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/wage-ledger/rule-and-policy',
      children: t('tabs.ruleAndPolicy'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/wage-ledger/operation-activity',
      children: t('tabs.operationActivity'),
      activeOptions: {
        exact: false
      }
    }, {
      to: '/wage-ledger/settings',
      children: t('tabs.settings'),
      activeOptions: {
        exact: false
      }
    }]} /> : null}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <Outlet />
      </div>
    </div>;
}